function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg2004(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "100%",
    width: "100%",
    viewBox: "0 0 700 700",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    key: 0,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 23.93,
    height: 8.54,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 1.22
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.965,
    y: 4.27,
    fontFamily: "Arial"
  }, "\n        Cameron\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 1,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 8.54,
    width: 23.93,
    height: 9.14,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 1.5233333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.965,
    y: 13.11,
    fontFamily: "Arial"
  }, "\n        Forest\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 2,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 17.68,
    width: 23.93,
    height: 11.66,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 1.4575
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.965,
    y: 23.509999999999998,
    fontFamily: "Arial"
  }, "\n        Sullivan\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 3,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 29.35,
    width: 23.93,
    height: 22.27,
    style: {
      fill: "#B20000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.7116666666666664
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.965,
    y: 40.485,
    fontFamily: "Arial"
  }, "\n        Fulton\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 4,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 51.61,
    width: 23.93,
    height: 27.07,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.4185714285714286
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.965,
    y: 65.145,
    fontFamily: "Arial"
  }, "\n        Montour\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 5,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 78.69,
    width: 23.93,
    height: 28.27,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.9883333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.965,
    y: 92.825,
    fontFamily: "Arial"
  }, "\n        Potter\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 6,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 106.96,
    width: 23.93,
    height: 35.53,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.4185714285714286
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.965,
    y: 124.725,
    fontFamily: "Arial"
  }, "\n        Juniata\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 7,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 142.49,
    width: 23.93,
    height: 45.57,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.4185714285714286
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.965,
    y: 165.275,
    fontFamily: "Arial"
  }, "\n        Wyoming\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 8,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 188.06,
    width: 23.93,
    height: 49.6,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.4185714285714286
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.965,
    y: 212.86,
    fontFamily: "Arial"
  }, "\n        Clinton\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 9,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 237.65,
    width: 23.93,
    height: 51.67,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.976666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.965,
    y: 263.485,
    fontFamily: "Arial"
  }, "\n        Elk\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 10,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 289.32,
    width: 23.93,
    height: 53.2,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.9883333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.965,
    y: 315.92,
    fontFamily: "Arial"
  }, "\n        Snyder\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 11,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 342.52,
    width: 23.93,
    height: 55.27,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.9883333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.965,
    y: 370.155,
    fontFamily: "Arial"
  }, "\n        Greene\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 12,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 397.79,
    width: 23.93,
    height: 57.25,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.786
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.965,
    y: 426.415,
    fontFamily: "Arial"
  }, "\n        Union\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 13,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 455.04,
    width: 23.93,
    height: 59.66,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.4185714285714286
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.965,
    y: 484.87,
    fontFamily: "Arial"
  }, "\n        Mifflin\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 14,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 514.71,
    width: 23.93,
    height: 61.02,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.4185714285714286
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.965,
    y: 545.22,
    fontFamily: "Arial"
  }, "\n        Clarion\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 15,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 575.73,
    width: 23.93,
    height: 61.88,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.9883333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.965,
    y: 606.6700000000001,
    fontFamily: "Arial"
  }, "\n        Mckean\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 16,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 637.61,
    width: 23.93,
    height: 62.39,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.786
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.965,
    y: 668.8050000000001,
    fontFamily: "Arial"
  }, "\n        Tioga\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 17,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 23.93,
    y: 0,
    width: 33.53,
    height: 45.77,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.353
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 40.695,
    y: 22.885,
    fontFamily: "Arial"
  }, "\n        Huntingdon\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 18,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 57.46,
    y: 0,
    width: 35.35,
    height: 45.77,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.213636363636364
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 75.135,
    y: 22.885,
    fontFamily: "Arial"
  }, "\n        Susquehanna\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 19,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 92.82,
    y: 0,
    width: 35.79,
    height: 45.77,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.965
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 110.71499999999999,
    y: 22.885,
    fontFamily: "Arial"
  }, "\n        Warren\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 20,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 128.6,
    y: 0,
    width: 36.07,
    height: 45.77,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.214
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 146.635,
    y: 22.885,
    fontFamily: "Arial"
  }, "\n        Perry\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 21,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 164.67,
    y: 0,
    width: 36.32,
    height: 45.77,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.035555555555556
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 182.82999999999998,
    y: 22.885,
    fontFamily: "Arial"
  }, "\n        Jefferson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 22,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 200.99,
    y: 0,
    width: 39.55,
    height: 45.77,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 9.8875
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 220.76500000000001,
    y: 22.885,
    fontFamily: "Arial"
  }, "\n        Pike\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 23,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 240.54,
    y: 0,
    width: 40.79,
    height: 45.77,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.158
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 260.935,
    y: 22.885,
    fontFamily: "Arial"
  }, "\n        Wayne\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 24,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 281.33,
    y: 0,
    width: 42.11,
    height: 45.77,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.015714285714286
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 302.385,
    y: 22.885,
    fontFamily: "Arial"
  }, "\n        Bedford\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 25,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 323.44,
    y: 0,
    width: 43.93,
    height: 45.77,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.275714285714286
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 345.405,
    y: 22.885,
    fontFamily: "Arial"
  }, "\n        Venango\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 26,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 367.37,
    y: 0,
    width: 46.5,
    height: 45.77,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.628333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 390.62,
    y: 22.885,
    fontFamily: "Arial"
  }, "\n        Carbon\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 27,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 413.87,
    y: 0,
    width: 47.63,
    height: 45.77,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.72125
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 437.685,
    y: 22.885,
    fontFamily: "Arial"
  }, "\n        Bradford\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 28,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 461.5,
    y: 0,
    width: 49.89,
    height: 45.77,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.72125
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 486.445,
    y: 22.885,
    fontFamily: "Arial"
  }, "\n        Columbia\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 29,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 511.39,
    y: 0,
    width: 57.74,
    height: 45.77,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.085555555555556
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 540.26,
    y: 22.885,
    fontFamily: "Arial"
  }, "\n        Armstrong\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 30,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 569.13,
    y: 0,
    width: 63.56,
    height: 45.77,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.577
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 600.91,
    y: 22.885,
    fontFamily: "Arial"
  }, "\n        Clearfield\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 31,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 632.69,
    y: 0,
    width: 67.31,
    height: 45.77,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.538571428571429
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 666.345,
    y: 22.885,
    fontFamily: "Arial"
  }, "\n        Indiana\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 32,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 23.93,
    y: 45.77,
    width: 60.28,
    height: 51.85,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.48125
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 54.07,
    y: 71.69500000000001,
    fontFamily: "Arial"
  }, "\n        Somerset\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 33,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 23.93,
    y: 97.62,
    width: 60.28,
    height: 52.35,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.7392857142857143
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 54.07,
    y: 123.795,
    fontFamily: "Arial"
  }, "\n        Northumberland\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 34,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 23.93,
    y: 149.97,
    width: 60.28,
    height: 54.03,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.75375
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 54.07,
    y: 176.985,
    fontFamily: "Arial"
  }, "\n        Crawford\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 35,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 23.93,
    y: 203.99,
    width: 60.28,
    height: 59.53,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 11.906
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 54.07,
    y: 233.755,
    fontFamily: "Arial"
  }, "\n        Adams\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 36,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 23.93,
    y: 263.53,
    width: 60.28,
    height: 61.24,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.535
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 54.07,
    y: 294.15,
    fontFamily: "Arial"
  }, "\n        Lawrence\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 37,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 23.93,
    y: 324.77,
    width: 60.28,
    height: 70.56,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.535
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 54.07,
    y: 360.04999999999995,
    fontFamily: "Arial"
  }, "\n        Lycoming\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 38,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 23.93,
    y: 395.33,
    width: 60.28,
    height: 72.69,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 10.046666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 54.07,
    y: 431.67499999999995,
    fontFamily: "Arial"
  }, "\n        Mercer\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 39,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 23.93,
    y: 468.02,
    width: 60.28,
    height: 76.38,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 12.056000000000001
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 54.07,
    y: 506.21,
    fontFamily: "Arial"
  }, "\n        Blair\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 40,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 23.93,
    y: 544.4,
    width: 60.28,
    height: 77.12,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.611428571428572
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 54.07,
    y: 582.96,
    fontFamily: "Arial"
  }, "\n        Fayette\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 41,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 23.93,
    y: 621.52,
    width: 60.28,
    height: 78.48,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.611428571428572
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 54.07,
    y: 660.76,
    fontFamily: "Arial"
  }, "\n        Lebanon\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 42,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 84.22,
    y: 45.77,
    width: 60.28,
    height: 79.43,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 10.046666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 114.36,
    y: 85.48500000000001,
    fontFamily: "Arial"
  }, "\n        Monroe\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 43,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 144.49,
    y: 45.77,
    width: 62.66,
    height: 79.43,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.8325
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 175.82,
    y: 85.48500000000001,
    fontFamily: "Arial"
  }, "\n        Franklin\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 44,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 207.16,
    y: 45.77,
    width: 68.74,
    height: 79.43,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 11.456666666666665
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 241.53,
    y: 85.48500000000001,
    fontFamily: "Arial"
  }, "\n        Centre\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 45,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 275.9,
    y: 45.77,
    width: 69.83,
    height: 79.43,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.983
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 310.815,
    y: 85.48500000000001,
    fontFamily: "Arial"
  }, "\n        Schuylkill\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 46,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 345.73,
    y: 45.77,
    width: 71.66,
    height: 79.43,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 10.237142857142857
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 381.56,
    y: 85.48500000000001,
    fontFamily: "Arial"
  }, "\n        Cambria\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 47,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 417.39,
    y: 45.77,
    width: 88.31,
    height: 79.43,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 13.238333333333335
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 461.54499999999996,
    y: 85.48500000000001,
    fontFamily: "Arial"
  }, "\n        Beaver\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 48,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 505.71,
    y: 45.77,
    width: 91.4,
    height: 79.43,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 13.238333333333335
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 551.41,
    y: 85.48500000000001,
    fontFamily: "Arial"
  }, "\n        Butler\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 49,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 597.1,
    y: 45.77,
    width: 102.9,
    height: 79.43,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.9430000000000005
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 648.5500000000001,
    y: 85.48500000000001,
    fontFamily: "Arial"
  }, "\n        Washington\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 50,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 84.22,
    y: 125.2,
    width: 106.72,
    height: 84.27,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.427
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 137.57999999999998,
    y: 167.335,
    fontFamily: "Arial"
  }, "\n        Lackawanna\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 51,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 84.22,
    y: 209.47,
    width: 106.72,
    height: 84.48,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.448
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 137.57999999999998,
    y: 251.71,
    fontFamily: "Arial"
  }, "\n        Cumberland\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 52,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 84.22,
    y: 293.95,
    width: 106.72,
    height: 96.53,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 13.790000000000001
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 137.57999999999998,
    y: 342.215,
    fontFamily: "Arial"
  }, "\n        Dauphin\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 53,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 84.22,
    y: 390.48,
    width: 106.72,
    height: 100.26,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 25.065
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 137.57999999999998,
    y: 440.61,
    fontFamily: "Arial"
  }, "\n        Erie\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 54,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 84.22,
    y: 490.74,
    width: 106.72,
    height: 100.93,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 9.175454545454546
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 137.57999999999998,
    y: 541.205,
    fontFamily: "Arial"
  }, "\n        Northampton\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 55,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 84.22,
    y: 591.67,
    width: 106.72,
    height: 108.33,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 15.245714285714286
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 137.57999999999998,
    y: 645.8349999999999,
    fontFamily: "Arial"
  }, "\n        Luzerne\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 56,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 190.93,
    y: 125.2,
    width: 110.65,
    height: 111.44,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 18.441666666666666
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 246.255,
    y: 180.92000000000002,
    fontFamily: "Arial"
  }, "\n        Lehigh\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 57,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 301.58,
    y: 125.2,
    width: 125.44,
    height: 111.44,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 22.288
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 364.29999999999995,
    y: 180.92000000000002,
    fontFamily: "Arial"
  }, "\n        Berks\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 58,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 427.02,
    y: 125.2,
    width: 136.27,
    height: 111.44,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 9.286666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 495.155,
    y: 180.92000000000002,
    fontFamily: "Arial"
  }, "\n        Westmoreland\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 59,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 563.29,
    y: 125.2,
    width: 136.71,
    height: 111.44,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 27.86
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 631.645,
    y: 180.92000000000002,
    fontFamily: "Arial"
  }, "\n        York\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 60,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 190.93,
    y: 236.64,
    width: 135.11,
    height: 139.19,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 15.012222222222224
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 258.485,
    y: 306.235,
    fontFamily: "Arial"
  }, "\n        Lancaster\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 61,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 190.93,
    y: 375.83,
    width: 135.11,
    height: 145.19,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 19.301428571428573
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 258.485,
    y: 448.42499999999995,
    fontFamily: "Arial"
  }, "\n        Chester\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 62,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 190.93,
    y: 521.02,
    width: 135.11,
    height: 178.98,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 16.88875
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 258.485,
    y: 610.51,
    fontFamily: "Arial"
  }, "\n        Delaware\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 63,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 326.04,
    y: 236.64,
    width: 166.25,
    height: 163.49,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 32.698
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 409.165,
    y: 318.385,
    fontFamily: "Arial"
  }, "\n        Bucks\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 64,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 492.28,
    y: 236.64,
    width: 207.72,
    height: 163.49,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 16.349
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 596.14,
    y: 318.385,
    fontFamily: "Arial"
  }, "\n        Montgomery\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 65,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 326.04,
    y: 400.13,
    width: 182.93,
    height: 299.87,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 20.325555555555557
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 417.505,
    y: 550.065,
    fontFamily: "Arial"
  }, "\n        Allegheny\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 66,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 508.97,
    y: 400.13,
    width: 191.03,
    height: 299.87,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 15.919166666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 604.485,
    y: 550.065,
    fontFamily: "Arial"
  }, "\n        Philadelphia\n      ")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg2004);
export default __webpack_public_path__ + "static/media/2004.cb656950415cc446ba97006d5d8a1192.svg";
export { ForwardRef as ReactComponent };